import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';

@Injectable()
export class FaqService {

    constructor(private httpClient: HttpClient) {

    }

    getQuestions() {
        return this.httpClient.get('./assets/json/faq.json?v=2').pipe(
            map(mapResponseWithData));
    }
}
